import script from "./FixedFeeTimeEntriesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./FixedFeeTimeEntriesTab.vue?vue&type=script&setup=true&lang=js"

import "./FixedFeeTimeEntriesTab.vue?vue&type=style&index=0&id=822ea90c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-822ea90c"]])

export default __exports__